export const Divider = () => {
  return <hr className='w-full border-t border-neutral-text-dark' />;
};
